import { useLayoutEffect } from "react";
import { getInitialResultsViewMode } from "~/features/search/utils/searchUtils";
import type { SearchDisplayMode } from "~/features/search/models/models";

export function useInitializeSRPResultsViewMode(
  isInit: boolean,
  isProductFamilySelected: boolean,
  setDisplayMode: (mode: SearchDisplayMode) => void,
) {
  useLayoutEffect(() => {
    if (isInit && !isProductFamilySelected) {
      setDisplayMode(getInitialResultsViewMode());
    }
  }, [isInit, isProductFamilySelected, setDisplayMode]);
}
